var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalanceUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.10765 9.27445C7.05043 9.33586 6.98143 9.38511 6.90476 9.41927C6.8281 9.45343 6.74534 9.4718 6.66142 9.47328C6.5775 9.47476 6.49414 9.45932 6.41632 9.42789C6.33849 9.39645 6.2678 9.34966 6.20845 9.29031C6.1491 9.23097 6.10231 9.16027 6.07088 9.08245C6.03944 9.00462 6.02401 8.92127 6.02549 8.83735C6.02697 8.75343 6.04534 8.67067 6.0795 8.594C6.11366 8.51734 6.16291 8.44834 6.22431 8.39112L9.55765 5.05778C9.67484 4.94074 9.83369 4.875 9.99931 4.875C10.1649 4.875 10.3238 4.94074 10.441 5.05778L13.7743 8.39112C13.8357 8.44834 13.885 8.51734 13.9191 8.594C13.9533 8.67067 13.9717 8.75343 13.9731 8.83735C13.9746 8.92127 13.9592 9.00462 13.9277 9.08245C13.8963 9.16027 13.8495 9.23097 13.7902 9.29031C13.7308 9.34966 13.6601 9.39645 13.5823 9.42789C13.5045 9.45932 13.4211 9.47476 13.3372 9.47328C13.2533 9.4718 13.1705 9.45343 13.0939 9.41927C13.0172 9.38511 12.9482 9.33586 12.891 9.27445L10.6243 7.00778V15.0828C10.6243 15.2485 10.5585 15.4075 10.4413 15.5247C10.324 15.6419 10.1651 15.7078 9.99931 15.7078C9.83355 15.7078 9.67458 15.6419 9.55737 15.5247C9.44016 15.4075 9.37431 15.2485 9.37431 15.0828V7.00778L7.10765 9.27445Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceUp);
export default __webpack_public_path__ + "static/media/BalanceUp.fc2265a5a5271b11b9616bd02b01432c.svg";
export { ForwardRef as ReactComponent };